var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"w-full",attrs:{"success":"","disabled":_vm.loading},on:{"click":_vm.createPerson}},[_vm._v(" New Person ")])
}
var staticRenderFns = []

export { render, staticRenderFns }